import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { capitalizeAll } from 'projects/common/src/app/services/utils/utilities';
import { IOperator } from 'src/app/modules/widget/interfaces/operator';
import { IFilter } from '../../../interfaces/filter-config';
import { FilterHandlerService } from '../../../services/filter/filter-handler.service';
import { GoogleAnalyticsService } from '../../../services/google/google-analytics.service';

@Component({
  selector: 'filter-operator',
  templateUrl: './filter-operator.component.html',
  styleUrls: ['./filter-operator.component.scss'],
})
export class FilterOperatorComponent implements AfterViewInit {
  @Input() public filter: IFilter;

  @Input() public set mine(mine: string) {
    this.operatorsParams.mine = Number(mine);
    if (mine !== undefined && this.operatorsParams.machineType) {
      this.getOperatorsByMineAndMachineType();
    } else {
      this.operators = [];
    }
  }

  @Input() public set machineType(machineType: string) {
    this.operatorsParams.machineType = Number(machineType);
    if (machineType !== undefined && this.operatorsParams.mine) {
      this.getOperatorsByMineAndMachineType();
    } else {
      this.operators = [];
    }
  }

  @Output() public operatorsChanged: EventEmitter<IOperator[]>;

  public operators: IOperator[];

  public selectedOption: any;

  public operatorsParams: any;

  constructor(
    private filterHandlerService: FilterHandlerService,
    private cdr: ChangeDetectorRef,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {
    this.operators = [];
    this.operatorsChanged = new EventEmitter<IOperator[]>();

    this.operatorsParams = { mine: null, machineType: null };
  }

  /**
   * App after view init
   */
  public ngAfterViewInit(): void {
    this.filterHandlerService.clearFilter$.subscribe(() => {
      if (!this.filter.uniqueSelection) {
        this.selectedOption = null;
      }
    });
  }

  /**
   * Function to change selected mine
   *
   * @param $event selected mine
   */
  public changeSelectedOption($event: IOperator[]): void {
    this.operatorsChanged.emit($event);
    this.selectedOption = $event;
    const filter = {
      filter_selected: 'filter_operator',
      value_selected: $event,
    };
    this.googleAnalyticsService.sendFilterEvent(filter);
  }

  /**
   * Function to get mines by machine type
   *
   * @param machineTypes Incoming machine type
   */
  public getOperatorsByMineAndMachineType(): void {
    if (this.operatorsParams.mine && this.operatorsParams.machineType) {
      this.filterHandlerService
        .getOperatorsBySelectedMine(Number(this.operatorsParams.mine), Number(this.operatorsParams.machineType))
        .then(
          (operators: IOperator[]) => {
            for (const operator of operators) {
              if (this.filter.multiselect) {
                (operator as any).selectedAllGroup = 'selectedAllGroup';
              }

              operator.label = capitalizeAll(`${operator.firstName} ${operator.lastName}`);
            }

            this.operators = operators;
            this.cdr.detectChanges();
          },
          () => {},
        );
    } else {
      this.operators = [];
      this.cdr.detectChanges();
    }
  }
}
